import { validate } from './validation';

const updateState = (vehicles, updatedVehicle, internalStateSetter, outlet, vehicleIndex) => {
  internalStateSetter({ vehicle: updatedVehicle });

  const updatedVehicles = vehicles.map((item, i) => {
    if (i === vehicleIndex) return updatedVehicle;
    return item;
  });

  outlet({ vehicles: updatedVehicles });
};

export default {
  'Vehicle.VehicleForm.Model': ({ vehicles, vehicleIndex, vehicle, value }, outlet, internalStateSetter) => {
    const updatedVehicle = { ...vehicle, modal: value, modalError: '', hasError: false  };
    updateState(vehicles, updatedVehicle, internalStateSetter, outlet, vehicleIndex,);
  },
  'Vehicle.VehicleForm.Color': ({ vehicles, vehicleIndex, vehicle, value }, outlet, internalStateSetter) => {
    const updatedVehicle = { ...vehicle, color: value, colorError: '', hasError: false };
    updateState(vehicles, updatedVehicle, internalStateSetter, outlet, vehicleIndex,);
  },
  'Vehicle.VehicleForm.LicensePlate': ({ vehicles, vehicleIndex, vehicle, value }, outlet, internalStateSetter) => {
    const updatedVehicle = { ...vehicle, licensePlate: value, licensePlateError: '', hasError: false };
    updateState(vehicles, updatedVehicle, internalStateSetter, outlet, vehicleIndex,);
  },
  'Vehicle.VehicleForm.State': ({ vehicles, vehicleIndex, vehicle, value }, outlet, internalStateSetter) => {
    const updatedVehicle = { ...vehicle, state: value, stateError: '', hasError: false };
    updateState(vehicles, updatedVehicle, internalStateSetter, outlet, vehicleIndex,);
  },
  'Vehicle.VehicleForm.DeleteButton': ({ resourceList: vehicles, vehicleIndex }, outlet) => {
    const filteredVehicles = vehicles.filter((_, i) => i !== vehicleIndex);
    outlet({ vehicles: filteredVehicles });
  }
};
